module.exports = __webpack_public_path__ + "static/media/BTECH_EXTC_2024-2028_Scheme.4ea70f5b.pdf";